export default __webpack_public_path__ + "static/rfq-apparel-2c30e8dc459fda82a2d80d19244c71e1.png";